import { render, staticRenderFns } from "./Animal.vue?vue&type=template&id=793db774&"
import script from "./Animal.vue?vue&type=script&lang=js&"
export * from "./Animal.vue?vue&type=script&lang=js&"
import style0 from "./Animal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports